import React from 'react';

export default function TrustedDevicesPanel({ devices, onRevoke }) {
  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown';
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'revoked':
        return 'bg-red-100 text-red-800';
      case 'expired':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const handleRevokeAll = () => {
    if (!window.confirm('Are you sure you want to revoke all trusted devices? You will need to authenticate again on all devices.')) {
      return;
    }
    devices?.filter(d => d?.status === 'active')?.forEach(device => {
      onRevoke(device?.id);
    });
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Trusted Devices</h2>
          <p className="text-sm text-gray-600 mt-1">Devices that can skip 2FA for a limited time</p>
        </div>
        {devices?.filter(d => d?.status === 'active')?.length > 0 && (
          <button
            onClick={handleRevokeAll}
            className="bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-red-700"
          >
            Revoke All
          </button>
        )}
      </div>
      {devices?.length === 0 ? (
        <div className="text-center py-12">
          <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <p className="text-gray-600">No trusted devices</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-3 px-4 font-semibold text-gray-700">Device</th>
                <th className="text-left py-3 px-4 font-semibold text-gray-700">Location</th>
                <th className="text-left py-3 px-4 font-semibold text-gray-700">Last Accessed</th>
                <th className="text-left py-3 px-4 font-semibold text-gray-700">Status</th>
                <th className="text-right py-3 px-4 font-semibold text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody>
              {devices?.map((device) => (
                <tr key={device?.id} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-4 px-4">
                    <div>
                      <p className="font-medium text-gray-900">{device?.deviceName}</p>
                      <p className="text-sm text-gray-500">{device?.browserInfo}</p>
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <div>
                      <p className="text-sm text-gray-900">{device?.location || 'Unknown'}</p>
                      <p className="text-xs text-gray-500">{device?.ipAddress}</p>
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <p className="text-sm text-gray-900">{formatDate(device?.lastAccessedAt)}</p>
                  </td>
                  <td className="py-4 px-4">
                    <span className={`text-xs font-semibold px-3 py-1 rounded-full ${getStatusColor(device?.status)}`}>
                      {device?.status?.charAt(0)?.toUpperCase() + device?.status?.slice(1)}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-right">
                    {device?.status === 'active' && (
                      <button
                        onClick={() => onRevoke(device?.id)}
                        className="text-red-600 hover:text-red-800 text-sm font-semibold"
                      >
                        Revoke
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}